export default ['PL','AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','ES','IE','LT','LU','LV','MT','NL','DE','PT','RO','SK','SI','SE','HU','IT'];
